module.exports = __webpack_public_path__ + "02_face.0c78b720.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/02_face.png
// module id = 6xOc
// module chunks = 0